import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CopyClipboardComponent } from "./copy-clipboard/copy-clipboard.component";
import { AreaConversionsPipe } from "./pipes/AreaConversionsPipe";
import { LatLongToDMSPipe } from "./pipes/LatLongToDMSPipe";
import { OrderByPipe } from "./pipes/OrderByPipe";
import { PercentagePipe } from "./pipes/PercentagePipe";
import { SpeedConversionsPipe } from "./pipes/SpeedConversionsPipe";
import { LengthConversionsPipe } from "./pipes/LengthConversionsPipe";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { LoadingComponent } from "./loading/loading.component";
import { FullScreenLoadingComponent } from "./full-screen-loading/full-screen-loading.component";
import { ImageLazyLoadDirective } from "./directives/image-lazy-load.directive";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
  declarations: [
    ImageLazyLoadDirective,
    CopyClipboardComponent,
    AreaConversionsPipe,
    LatLongToDMSPipe,
    OrderByPipe,
    PercentagePipe,
    SpeedConversionsPipe,
    LengthConversionsPipe,
    LoadingComponent,
    FullScreenLoadingComponent,
  ],
  imports: [CommonModule, MatIconModule, MatTooltipModule, MatButtonModule],
  exports: [
    ImageLazyLoadDirective,
    CopyClipboardComponent,
    AreaConversionsPipe,
    LatLongToDMSPipe,
    OrderByPipe,
    PercentagePipe,
    SpeedConversionsPipe,
    LengthConversionsPipe,
    LoadingComponent,
    FullScreenLoadingComponent,
  ],
})
export class SharedComponentsModule {}
